<template>
  <div class="home" v-if="show" v-loading="loading">
    <div class="content">
      <!-- ============大图============ -->
      <div :class="isMobile?'phoneImg':'bigImg'">
        <el-carousel height="286px" direction="horizontal" :autoplay="true" arrow="never">
          <el-carousel-item v-for="item in carouselData.dblb" :key="item.id">
            <img :src="`/api${item.fileUrl}`" width="100%" height="100%" alt="暂无图片">
            <!-- <img src="../assets/foot.png" width="100%" height="100%" alt=""> -->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- ================行业新闻  和  政策法规 一行============ -->
      <div :class="isMobile?'oneLine2':'oneLine'">
        <!-- 行业新闻 -->
        <div class="leftpos">
          <div class="newsHeader">
            <div class="news_left">行业新闻</div>
            <span @click="jump('6-1')">更多 <img src="../assets/jiantou.png" alt=""></span>
          </div>

          <div class="newsBody">
            <div class="c_rotation">
          <el-carousel :interval="5000" height="217px" trigger="click" direction="horizontal" :autoplay="true">
            <el-carousel-item v-for="item in blanceImg" :key="item.id">
              <img
                :src="`/api${item.fileUrl}`"
                @click="jump2(item.bussinessId)"
                style="cursor: pointer"
                alt="暂无图片"
              />
              <span class="test">
                <!-- <label>{{ item.title | dataShow3 }}</label> -->
              </span>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="c_rightmes">
          <div class="c_mes">
            <!-- <vue-seamless-scroll :data="listdata" class="seamless-warp">
              <ul>
                <li v-for="(item, index) in listdata.allList" :key="index">
                    <span class="icon_top" v-if="item.isTop == 1">置顶</span>
                    <i class="right_go"></i>
                    <span class="first_text" v-text="item.title"></span>
                    <span class="c_date">{{ item.createTime | dataFormat }}</span>
                </li>
              </ul>
            </vue-seamless-scroll> -->
            <!-- <vue-seamless-scroll :data="listdata.allList" class="seamless-warp" :class-option="classOption"> -->
            <div class="seamless-warp">
              <ul>
                <li v-for="(item, index) in listdata.xyxw" :key="index">
                  <!-- <span class="icon_top" v-if="item.isTop == 1">置顶</span> -->
                  <i class="right_go"></i>
                  <span
                    class="first_text"
                    @click="jump2(item.id)"
                    :title="item.title"
                    >{{ item.title | dataShow2 }}</span
                  >
                  <span class="c_date">[{{ item.createTime | dataFormat }}]</span>
                </li>
              </ul>
            </div>
            <!-- </vue-seamless-scroll> -->
          </div>
        </div>
          </div>
        </div>

        <!-- 政策法规 -->
        <div class="rightTops">
          <div class="policyHeader">
            <div class="policy_left">政策法规</div>
            <span @click="jump('6-0')">更多 <img src="../assets/jiantou.png" alt=""></span>
          </div>

          <div class="policyBody">
            <div class="seamless-warp">
            <!-- <vue-seamless-scroll :data="listdata.allList" class="seamless-warp" :class-option="classOption"> -->
              <ul>
                <li v-for="(item, index) in listdata.zcfg" :key="index">
                  <!-- <span class="icon_top" v-if="item.isTop == 1">置顶</span> -->
                  <i class="right_go"></i>
                  <span
                    class="first_text"
                    @click="jump2(item.id)"
                    :title="item.title"
                    >{{ item.title | dataShow5 }}</span
                  >
                  <span class="c_date">{{ item.createTime | dataFormat }}</span>
                </li>
              </ul>
            </div>
            <!-- </vue-seamless-scroll> -->
          </div>
        </div>
      </div>
      <!-- ===================行协通知===================== -->
      <div :class="isMobile?'twoLine oneLine2':'twoLine oneLine'">
        <div class="leftpos">
          <div class="newsHeader">
            <div class="news_left">行协通知</div>
            <span @click="jump('4-2')">更多 <img src="../assets/jiantou.png" alt=""></span>
          </div>

          <div class="newsBody association">
            <div>
              <div class="associationHd" v-if="firstItem.isTop == 1" @click="jump2(firstItem.id)">
                <span>{{firstItem.title}}</span>
              </div>
              <div class="associationHd" v-else @click="jump2(firstItem.id)">
                <span>{{firstItem.title}}</span>
              </div>
              <div class="associationBd" v-if="firstItem.isTop == 1" @click="jump2(firstItem.id)">
                <span>{{firstItem.text}}</span>
              </div>

              <div class="associationBd" v-else @click="jump2(firstItem.id)">
                <span>{{firstItem.text}}</span>
              </div>
            </div>
            <div class="associationBd2">
              <div class="left_b">
                <ul>
                  <li v-for="items in listdata.xxtz.slice(1,5)" :key="items.id" @click="jump2(items.id)">
                    <span v-if="items.isTop != 1">· {{items.title | dataShow}}</span>
                  </li>
                </ul>
              </div>
              <div class="right_b">
                <ul>
                  <li v-for="newItem in listdataXxtz" :key="newItem.id" @click="jump2(newItem.id)">· {{newItem.title | dataShow}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ===============四个按钮区域============== -->
        <div class="openGo">
          <div class="c_button">
            <div class="c_butlist" @click="linkNew('kaowu')">考务中心管理入口</div>
            <div class="c_butlist" @click="linkNew('menhu')">门户网站后台入口</div>
            <div class="c_butlist" @click="jump(1)">人才招聘详情查看</div>
            <div class="c_butlist" @click="jump(3)">下载中心详情查看</div>
          </div>
        </div>
      </div>
      <!-- ===================中部大图=================== -->
      <div :class="isMobile?'footimg2':'footimg'"><img v-for="item in carouselData.zbct" :key="item.id" :src="`/api${item.fileUrl}`" alt="暂无图片" /></div>
      <!-- ===================底部三栏===================== -->
      <div :class="isMobile?'c_noticebox2':'c_noticebox'">
        <div class="c_frame">
          <div class="c_row">
            <div class="c_noticelefttop">行协新闻</div>
            <div class="c_noticetext" @click="jump(4)">更多 <img src="../assets/jiantou.png" alt=""></div>
          </div>
          <div class="c_mes c_mes2">
            <ul>
              <li v-for="item in listdata.xxxw" :key="item.id">
                <span class="icon_top" v-if="item.isTop == 1">置顶</span>
                <span
                  class="first_text"
                  @click="jump2(item.id)"
                  :title="item.title"
                  >· {{item.title | dataShow2}}</span
                >
                <!-- <span class="c_date">{{ item.createTime | dataFormat }}</span> -->
              </li>
            </ul>
          </div>
        </div>

        <div class="c_frame">
          <div class="c_row">
            <div class="c_noticelefttop">会员单位</div>
            <div class="c_noticetext" @click="jump('2-0')">更多 <img src="../assets/jiantou.png" alt=""></div>
          </div>
          <div class="c_mes c_mes2">
            <vueSeamlessScroll :data="memberData" :class-option="classOption">
              <ul>
                <li v-for="item in memberData" :key="item.id">
                  <!-- <span class="icon_top" v-if="item.isTop == 1">置顶</span> -->
                  <span
                    class="first_text"
                    @click="jump2(item.id)"
                    :title="item.title"
                    >· {{item.title | dataShow2}}</span
                  >
                  <!-- <span class="c_date">{{ item.createTime | dataFormat }}</span> -->
                </li>
              </ul>
            </vueSeamlessScroll>
            <!-- <ul>
              <li v-for="item in memberData" :key="item.id">
                <span class="icon_top" v-if="item.isTop == 1">置顶</span>
                <span
                  class="first_text"
                  @click="jump2(item.id)"
                  :title="item.title"
                  >· {{item.title | dataShow2}}</span
                >
                <span class="c_date">{{ item.createTime | dataFormat }}</span>
              </li>
            </ul> -->
          </div>
        </div>

        <div class="c_frame">
          <div class="c_row">
            <div class="c_noticelefttop">文学天地</div>
            <div class="c_noticetext" @click="jump('2-1')">更多 <img src="../assets/jiantou.png" alt=""></div>
          </div>
          <div class="c_mes c_mes2">
            <ul>
              <li v-for="item in listdata.wxtd" :key="item.id">
                <span class="icon_top" v-if="item.isTop == 1">置顶</span>
                <span
                  class="first_text"
                  @click="jump2(item.id)"
                  :title="item.title"
                  >· {{item.title | dataShow2}}</span
                >
                <!-- <span class="c_date">{{ item.createTime | dataFormat }}</span> -->
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- <img class="c_img" src="../assets/foot.png" alt="test" /> -->
    </div>

    <!-- ====================底部轮播图==================== -->
    <div :class="isMobile?'lunbo2':'lunbo'">
      <div class="l_frame">
        <li
          v-for="(item, index) in footimg"
          :key="index"
          @click="jump2(item.id)"
          style="text-align: center"
        >
          <img class="c_img" :src="item.src" alt="test" />
          <!-- <label>{{item.title==null?'...':item.title.title}}</label> -->
          <label>{{ item.title | dataShow4 }}</label>
        </li>

        <li
          v-for="itemt in footimg"
          :key="itemt.index"
          @click="jump2(itemt.id)"
          style="text-align: center"
        >
          <img class="c_img" :src="itemt.src" alt="test" />
          <!-- <label>{{item.title==null?'...':item.title.title}}</label> -->
          <label>{{ itemt.title | dataShow4 }}</label>
        </li>
      </div>
    </div>

    <!-- =======================底部图片======================= -->
    <div :class="isMobile?'foot_link2':'foot_link'">
      <!--<img @click="linkNew('http://www.dgdlhx.org/index.asp')" src="../assets/1.png" alt="">-->
      <!--<img @click="linkNew('http://www.dgdlhx.org/index.asp')" src="../assets/2.png" alt="">-->
      <img
        v-for="i in carouselData.dbzs"
        :key="i.id"
        @click="openUrl(i.webAddress)"
        :src="`/api${i.fileUrl}`"
        alt="暂无图片"
      />
      <!--<img @click="linkNew('http://www.dgdlhx.org/index.asp')" src="../assets/4.png" alt="">-->
      <!--<img @click="linkNew('http://www.dgdlhx.org/index.asp')" src="../assets/5.png" alt="">-->
    </div>


    <div :class="isMobile?'footer_dizhi2':'footer_dizhi'">
      <div class="dizhi_left">
        <div class="left_flex">
          <div>联系我们</div>
          <div>联系电话： 0752-8852518</div>
          <div>电子邮箱：hzdlxh@126.com</div>
        </div>
      </div>
      <div class="dizhi_center">
        <div class="right_flex">
          <div style="color:transparent;">--</div>
          <div>地址：惠州市惠城区下角埔前街二巷12号</div>
          <div>邮编：516001</div>
          <div>粤公网安备4413012002800002号 粤ICP备2020139638号-1</div>
        </div>
      </div>
      <div class="dizhi_right">
        <img src="@/assets/footerERWE.png" alt="" width="27%">
        <div>官方微信公众号</div>
      </div>
    </div>

    <footer :class="isMobile?'footer2':'footer'">
      <!-- 粤公网安备4413012002800002号 粤ICP备2020139638号-1 -->
    </footer>
    

    <!-- <div id="thediv" @mouseover="clearFdAd" @mouseout="starFdAd" v-show="theDivShow">
      <div style="position: absolute;right:0;cursor: pointer;font-size: 12px;color: #999999;" v-show="closeShow" @click="theDivShow = false">
            <img src="@/assets/closeLogo.png" width="100%" border="0"/>
        </div>
        <img src="@/assets/erweima.jpg" width="100%" border="0"/>
    </div> -->

  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "Home",
  components:{
    vueSeamlessScroll
  },
  data() {
    return {
      // closeShow:false,
      // theDivShow:true,

      loading:true,
      classOption: {
        step: 0.5
      },
      logo: "",
      text: "test",
      show: false,
      firstItem:{},
      rolist: [
        //测试图片
        { src: require("../assets/rot.png") },
        { src: require("../assets/rot.png") },
        { src: require("../assets/rot.png") },
      ],
      listdata: null,
      listDataNew:null,
      blanceImg: [],
      imgdata: [],
      allmsg: [],
      footimg: [],
      powerPage:{
        pageNum:"",
        limit:"",
        type: "2"
      },
      memberData:[],

      carouselData: [],

      listdataXxtz:[],
      isMobile:false
    };
  },
  created(){
    this.getFindArticalList()
    // debugger
    this.getScreen()
  },
  methods: {
    clearFdAd() {
        this.closeShow = true
    },
    starFdAd() {
        this.closeShow = false
    },
    getScreen() {
      if (
        navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      ) {
        this.isMobile = true;
        // console.log("手机");
      } else {
        this.isMobile = false;
        // console.log("pc");
      }
    },
    openUrl(url){
      // debugger
      // window.location.href= url
      // console.log(url.split('www'));
      if(url.substr(0,7).toLowerCase() == "http://"){
        window.open(`${url}`,"_block");
      }else{
        window.open(`http://${url}`,"_block");
      }
      // if (url.split('http')) {
      // }
    },
    linkNew(name) {
      // 考务后台
      // 'http://exam.hzdlhx.org.cn/#/login?redirect=%2Fdashboard'
      // 门户后台
      // 'http://exam.hzdlhx.org.cn/#/login?power=2'
      // if (name == 'kaowu') {
      //   window.open('https://www.hzdlhx.org.cn:9528/kaowu/#/login?redirect=%2Fdashboard')
      // }else {
      //   window.open('https://www.hzdlhx.org.cn:9528/kaowu/#/login?power=2')
      // }
      // if (name == 'kaowu') {
      //     window.open('https://exam.hzdlhx.org.cn:9528/kaowu/#/login?redirect=%2Fdashboard')
      //   }else {
      //     window.open('https://exam.hzdlhx.org.cn:9528/kaowu/#/login?power=2')
      //   }


      // if (window.location.port == '9528') {
      //   if (name == 'kaowu') {
      //     window.open('https://exam.hzdlhx.org.cn:9528/kaowu/#/login?redirect=%2Fdashboard')
      //   }else {
      //     window.open('https://exam.hzdlhx.org.cn:9528/kaowu/#/login?power=2')
      //   }
      // }else {
      //   if (name == 'kaowu') {
      //     window.open('http://218.14.113.34:9628/kaowu/#/login?redirect=%2Fdashboard')
      //   }else {
      //     window.open('http://218.14.113.34:9628/kaowu/#/login?power=2')
      //   }
      // }


      if (name == 'kaowu') {
        window.open('https://www.hzdlhx.org.cn/kaowu/#/login?redirect=%2Fdashboard')
      }else {
        window.open('https://www.hzdlhx.org.cn/kaowu/#/login?power=2')
      }
    },
    jump(num) {
      // console.log(num,'num');
      if (num == 0) return;
      if (num == 1) this.$router.push({ path: "/TalentRecruitment" ,query:{num:0}});
      if (num === '2-0') this.$router.push({ path: "/MemberCenter",query:{num:3}});
      if (num === '2-1') this.$router.push({ path: "/MemberCenter" ,query:{num:0}});
      if (num === '2-2') this.$router.push({ path: "/MemberCenter" ,query:{num:1}});

      if (num == 3) this.$router.push({ path: "/DownloadCenter" ,query:{num:0}});
      if (num == 4) this.$router.push({ path: "/Industrytrends" ,query:{num:0}});
      if (num === '4-2') this.$router.push({ path: "/Industrytrends" ,query:{num:2}});

      if (num == 5) this.$router.push({ path: "/TalentRecruitment" ,query:{num:0}});
      // if (num == 6) this.$router.push({ path: "/IndustryInformation" ,query:{num:1}});
      if (num === '6-0') this.$router.push({ path: "/IndustryInformation" ,query:{num:0}});
      if (num === '6-1') this.$router.push({ path: "/IndustryInformation" ,query:{num:1}});

      if (num == 7) this.$router.push({ path: "/IndustryProfile" ,query:{num:0}});
    },
    jump2(data) {
      // console.log(data, "test");
      this.$router.push({
        path: "/ContentDetails",
        query: { pos1: "内容详情", pos2: "", data: data },
      });
    },
    getFindArticalList(){
      this.$axios({
        method: "GET",
        url: "/tourist/findArticalList",
        params: this.powerPage
      }).then((res) => {
        // console.log(res,'res');
        if (res.status === 200) {
          this.loading = false;
          // console.log(res,'res');
          this.memberData = res.data.data.list
          // console.log(this.memberData,'memberData');
        }
      });
    }
  },
  mounted() {
    this.$axios({
      method: 'GET',
      url:"tourist/findPictureManagement"
    }).then(res=>{
      if(res.status == 200){
        this.carouselData = res.data.data
        // console.log(this.carouselData.dblb,'13413413');
      }
    });


    // console.log("-----------------1---");
    // http://192.168.30.12:1235/article/findIndexData//
    // filePortal/findLogoShowList
    this.$axios({
      method: "GET",
      url: "https://exam.hzdlhx.org.cn:9528/api/tourist/findLogoShowList",
    }).then((res) => {
      this.logo = res.data.data.map((val, index) => {
        return {
          src: "/api" + val.fileUrl,
          id: index,
          href: val.webAddress,
        };
      });
    });

    // console.log("-----------2---------");
    // 方框里面的通知数据
    this.$axios({
      method: "GET",
      url: "tourist/findIndexData",
      // url:"tourist/findPictureManagement"
    })
      .then((response) => {
        // console.log(response, "---------findIndexData-----------");
        this.listdata = response.data.data;
        
        this.show = true;
        // this.blanceImg = response.data.data.balanceList;
        // console.log(response.data, "this test");
        this.listdataXxtz = response.data.data.xxtz.slice(5,9)

        this.firstItem = this.listdata.xxtz[0]
        // this.allmsg = this.blanceImg.map((val, index) => {
        //   return {
        //     src: "/api" + val.fileUrl,
        //     id: val.bussinessId,
        //     title: val.article.title,
        //   };
        // });
        // console.log(this.allmsg,'allmsg')
        // console.log(response.data.data.bottomBalance,'here footimg')
        // this.footimg = response.data.data.bottomBalance;
        // this.footimg = response.data.data.bottomBalance.map((val, index) => {
        //   console.log(val,'val');
        //   if (val.title == null) {
        //     val.title = " ";
        //   }
        //   return {
        //     src: "/api" + val.fileUrl,
        //     id: val.bussinessId,
        //     title: val.article.title,
        //   };
        // });
        // console.log(this.footimg,"ssssssssssssssss")
      })
      .catch((err) => {
        window.alert(err);
      });


      this.$axios({
      method: "GET",
      url: "tourist/bottomBalance",
      // url:"tourist/findPictureManagement"
    }).then(response=>{
      this.footimg = response.data.data.bottomBalance.map((val, index) => {
          // console.log(val,'val');
          if (val.title == null) {
            val.title = " ";
          }
          return {
            src: "/api" + val.fileUrl,
            id: val.bussinessId,
            title: val.article.title,
          };
        });
    })

    this.$axios({
      method: "GET",
      url: "tourist/balanceList",
      // url:"tourist/findPictureManagement"
    }).then(response=>{
      this.blanceImg = response.data.data.balanceList;
      this.allmsg = this.blanceImg.map((val, index) => {
          return {
            src: "/api" + val.fileUrl,
            id: val.bussinessId,
            title: val.article.title,
          };
        });
    })
    
    // var id = window.sessionStorage.getItem("hyzx");
    //   this.$axios({
    //   method: "GET",
    //   url: "/tourist/findColumnByParentIdAndMenuId",
    //   params: {
    //     parentId: id,
    //     menuSign: 1,
    //   },
    // }).then((res) => {
    //   console.log(res.data.data, "-----------");
    //   this.list = res.data.data;

    //   //2
    //   // http://localhost:9966/api/article/findArticalList?columnId=f7ad8282b445420c9a15959bab408352&pageNum=1&limit=10&type=1
    //   // this.$axios({
    //   //   method: "GET",
    //   //   url: "/tourist/findArticalList",
    //   //   params: {
    //   //     columnId: res.data.data[0].value,
    //   //     pageNum: this.pageNum,
    //   //     limit: this.limit,
    //   //     type: "1",
    //   //   },
    //   // }).then((res) => {
    //   //   console.log(res,'res');
    //   // });
    //   //2
    // });
  },
  filters: {
    
    dataFormat(msg) {
      var rs = msg.slice(0, 10);
      return rs;
    },
    dataShow(msg) {
      if (msg.length >= 15) {
        var res = msg.slice(0, 22);
        return res;
      } else {
        return msg;
      }
    },
    dataShow2(msg) {
      if (msg.length >= 17) {
        var res = msg.slice(0, 18) + "...";
        return res;
      } else {
        return msg;
      }
    },
    dataShow3(msg) {
      if (msg.length >= 35) {
        var res = msg.slice(0, 35) + "...";
        return res;
      } else {
        return msg;
      }
    },
    dataShow4(msg) {
      if (typeof msg != "undefined") {
        if (msg.length >= 18) {
          var res = msg.slice(0, 18) + "...";
          return res;
        } else {
          return msg;
        }
      } else {
        return msg;
      }
    },
    dataShow5(msg) {
      if (msg.length >= 12) {
        var res = msg.slice(0, 11) + "...";
        return res;
      } else {
        return msg;
      }
    }
  },
};
</script>
<style lang="less">
// #thediv {
//     z-index: 999999;
//     position:fixed;
//     top: 45%;
//     right: 15px;
//     // height: 100px;
//     height: 150px;
//     // width: 200px;
//     //overflow: hidden;

//     img {
//         width: 100%;
//         height: 100%;
//         image-rendering: -moz-crisp-edges; /* Firefox */
//         image-rendering: -o-crisp-edges; /* Opera */
//         image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
//         image-rendering: crisp-edges;
//         -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
//     }
// }

.el-loading-spinner {
  top:15% !important;
}
.footer {
  color: #a4a7ab;
  font-size: 12px;
  text-align: center;
  line-height: 26px;
  width: 1050px;
  height: 26px;
  float: left;
  // margin: 0px 21%;
  margin-left: 50%;
  transform: translateX(-50%);
  // margin-left: 494px;
  margin-top: 21px;

  // border-top: 1px solid rgba(199, 199, 199, 1);
  padding-bottom: 50px;
}
.footer2 {
  color: #a4a7ab;
  font-size: 12px;
  text-align: center;
  line-height: 26px;
  width: 1050px;
  height: 26px;
  float: left;
  // margin: 0px 21%;
  margin-left: inherit;
  // transform: translateX(-50%);
  // margin-left: 494px;
  margin-top: 21px;

  // border-top: 1px solid rgba(199, 199, 199, 1);
  padding-bottom: 50px;
}
.bigImg {
    width: 1328px;
    height:286px;
    border: 2px solid rgba(225, 225, 225, 1);
    margin-left: 50%;
    transform: translate(-50%);
    .el-carousel__indicator--horizontal {
      left: 0px !important;
      margin-bottom: 20px !important;
    }
    .el-carousel__indicator--horizontal {
      padding: 12px 18px;
    }
  }
  .phoneImg {
    width: 1020px;
    height:286px;
    border: 2px solid rgba(225, 225, 225, 1);
    margin-left: inherit;
    // transform: translate(-50%);
    .el-carousel__indicator--horizontal {
      left: 0px !important;
      margin-bottom: 20px !important;
    }
    .el-carousel__indicator--horizontal {
      padding: 12px 18px;
    }
  }
.home {
  display: flex;
  flex-direction: column;
}
.footimg2 {
  margin-top: 10px;
  margin-left: inherit;
  // transform: translate(-50%);
  // width: 968px;
  width: 1020px;
  height: 147px;
  img {
    width: 100%;
    height: 100%;
  }
}
.footimg {
  margin-top: 10px;
  margin-left: 50%;
  transform: translate(-50%);
  // width: 968px;
  width: 1020px;
  height: 147px;
  img {
    width: 100%;
    height: 100%;
  }
}
.foot_link2 {
  // width: 990px;
  width: 1045px;
  border: 1px solid rgba(225, 225, 225, 1);
  height: 50px;
  margin-left: inherit;
  // transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  img {
    width: 20%;
  }
  img:hover {
    cursor: pointer;
  }
}
.foot_link {
  // width: 990px;
  width: 1045px;
  border: 1px solid rgba(225, 225, 225, 1);
  height: 50px;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  img {
    width: 20%;
  }
  img:hover {
    cursor: pointer;
  }
}
.footer_dizhi2 {
  width: 1045px;
  // margin-left: 50%;
  // transform: translate(-70%);
  display: flex;
  justify-content: center;
  // flex-direction: row;
  margin-top: 30px;
  .dizhi_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    .left_flex {
      div {
        &:nth-child(1) {
  
        }
        &:nth-child(2) {
          color: #a4a7ab;
          font-size: 12px;
          margin: 15px 0 ;
        }
        &:nth-child(3) {
          color: #a4a7ab;
          font-size: 12px;
        }
      }
    }
  }
  .dizhi_center {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    .right_flex {
      
      div {
        &:nth-child(1) {
          
        }
        &:nth-child(2) {
          color: #a4a7ab;
          font-size: 12px;
          margin: 15px 0 ;
        }
        &:nth-child(3) {
          color: #a4a7ab;
          font-size: 12px;
        }
        &:nth-child(4) {
          margin-top: 15px;
          color: #a4a7ab;
          font-size: 12px;
        }
      }
    }
  }
  .dizhi_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    div {
      margin-top: 5px;
      color: #a4a7ab;
      font-size: 12px;
    }
  }
}
.footer_dizhi {
  width: 1045px;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-around;
  // flex-direction: row;
  margin-top: 30px;
  .dizhi_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    .left_flex {
      div {
        &:nth-child(1) {
  
        }
        &:nth-child(2) {
          color: #a4a7ab;
          font-size: 12px;
          margin: 15px 0 ;
        }
        &:nth-child(3) {
          color: #a4a7ab;
          font-size: 12px;
        }
      }
    }
  }
  .dizhi_center {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    .right_flex {
      
      div {
        &:nth-child(1) {
          
        }
        &:nth-child(2) {
          color: #a4a7ab;
          font-size: 12px;
          margin: 15px 0 ;
        }
        &:nth-child(3) {
          color: #a4a7ab;
          font-size: 12px;
        }
        &:nth-child(4) {
          margin-top: 15px;
          color: #a4a7ab;
          font-size: 12px;
        }
      }
    }
  }
  .dizhi_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 3);
    div {
      margin-top: 5px;
      color: #a4a7ab;
      font-size: 12px;
    }
  }
}
@keyframes myfirst {
  from {
    left: 0;
  }
  to {
    left: -252%;
  }
}
.lunbo {
  background-color: white;
  // width: 990px;
  width: 1045px;
  // margin: 0 20%;
  margin-left:50%;
  transform: translate(-50%);
  border: 1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  margin-top: 20px;
  .l_frame {
    width: 100000px;
    height: 176px;
    position: relative;
    animation: myfirst 34s infinite linear;
    background-color: white;
  }
  .l_frame:hover {
    animation-play-state: paused;
  }
  li {
    float: left;
    width: 220px;
    height: 138px;
    list-style-type: none;
    margin: 8px 0;
    margin-left: 12px;
    img {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    label {
      position: relative;
      top: 5px;
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      left: 5px;
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.lunbo2 {
  background-color: white;
  // width: 990px;
  width: 1045px;
  // margin: 0 20%;
  margin-left:inherit;
  // transform: translate(-50%);
  border: 1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  margin-top: 20px;
  .l_frame {
    width: 100000px;
    height: 176px;
    position: relative;
    animation: myfirst 34s infinite linear;
    background-color: white;
  }
  .l_frame:hover {
    animation-play-state: paused;
  }
  li {
    float: left;
    width: 220px;
    height: 138px;
    list-style-type: none;
    margin: 8px 0;
    margin-left: 12px;
    img {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    label {
      position: relative;
      top: 5px;
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      left: 5px;
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.oneLine2 {
  display: flex;
  justify-content: space-between;
  // width: 959px;
  width:1020px;
  // border:1px solid #ccc;
  margin-top:15px;
  // margin-left: inherit;
  // transform: translate(-50%);
  .leftpos {
    // padding: 0px 20%;
    // width: 645px;
    width: 705px;
    height: 277px;
    border: 1px solid rgba(225, 225, 225, 1);
    // margin-left: 50%;
    // transform: translate(-50%);
    .newsHeader {
      // width: 645px;
      width: 705px;
      height: 36px;
      background-color: #f2f2f2;
      margin-bottom: 12px;
      .news_left {
        font-family:'微软雅黑';
        float: left;
        width: 124px;
        height: 36px;
        background-color:#1b7aca;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        text-align: center;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
        // font-weight: 700;
      }
    }
    .newsBody {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 229px;
    }
    .association {
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      padding:0 15px;
      box-sizing: border-box;
      div {
        margin-bottom: 10px;
      }
      .associationHd {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        span {
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd {
        font-size: 14px;
        color: #b0adad;
        text-indent: 2em;
        // width: 200px;
        span {
          overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        // display:block;
        // width: 615px;
        width: 680px;
        // height: 50px;
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd2 {
        display: flex;
        justify-content: space-around;
        // border:1px solid #ccc;
        // padding:0 15px;
        box-sizing: border-box;
        .left_b {
          padding-right: 15px;
          flex: 1;
          // margin-left:20px;
          // text-align: center;
          border-right: 1px solid rgba(225, 225, 225, 1);
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
        .right_b {
          flex: 1;
          margin-left:15px;
          // text-align: center;
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
      }
    }
  }
  .rightTops {
    width: 297px;
    height: 277px;
    // border: 1px solid #ccc;
    .policyHeader {
      width: 297px;
      height: 36px;
      background: url('../assets/policy.png') no-repeat;
      // background-color: #fff;
      .policy_left {
        float: left;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        // text-align: center;
        margin-left: 14%;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .policyBody {
      width: 297px;
      height: 236px;
      border: 1px solid rgba(225, 225, 225, 1);
      margin-top: 7px;
      padding: 0 10px;
      box-sizing: border-box;
        .seamless-warp {
        width: 100%;
        height: 217px;
        overflow: hidden;
        ul {
          color: #93969b;
          .icon_top {
            font-size: 12px;
            padding-left: 5px;
            padding-right: 6px;
            border: 1px solid rgba(179, 0, 0, 1);
            color: rgba(179, 0, 0, 1);
            border-radius: 4px;
          }
          .icon_top:active {
            color: none;
          }
          li {
            display: flex;
            align-items: center;
            justify-content:space-between;
            box-sizing: border-box;
            width: 100%;
            height: 14px;
            line-height: 32px;
            padding: 20px 0;
            list-style: none;
            border-bottom: 1px dashed rgba(225, 225, 225, 1);
            .right_go {
              float: left;
              width: 5px;
              height: 9px;
              // background-color: red;
              background: url('../assets/right.png') no-repeat;
            }
            .first_text {
              font-size: 14px;
              flex: 1;
              margin-left: 5px;
            }
            span {
              color: #3d3d3d;
            }
            .first_text:hover {
              cursor: pointer !important;
              text-decoration: underline !important;
              color: #30699b !important;
            }
            .first_text:active {
              color: #30699b;
            }
            .c_date {
              float: right;
              color: #999ca1;
              // margin-right: 15px;
            }
          }
          li:nth-child(1) {
            padding-top: 0;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
.oneLine {
  display: flex;
  justify-content: space-between;
  // width: 959px;
  width:1020px;
  // border:1px solid #ccc;
  margin-top:15px;
  margin-left: 50%;
  transform: translate(-50%);
  .leftpos {
    // padding: 0px 20%;
    // width: 645px;
    width: 705px;
    height: 277px;
    border: 1px solid rgba(225, 225, 225, 1);
    // margin-left: 50%;
    // transform: translate(-50%);
    .newsHeader {
      // width: 645px;
      width: 705px;
      height: 36px;
      background-color: #f2f2f2;
      margin-bottom: 12px;
      .news_left {
        font-family:'微软雅黑';
        float: left;
        width: 124px;
        height: 36px;
        background-color:#1b7aca;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        text-align: center;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
        // font-weight: 700;
      }
    }
    .newsBody {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 229px;
    }
    .association {
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      padding:0 15px;
      box-sizing: border-box;
      div {
        margin-bottom: 10px;
      }
      .associationHd {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        span {
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd {
        font-size: 14px;
        color: #b0adad;
        text-indent: 2em;
        // width: 200px;
        span {
          overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        // display:block;
        // width: 615px;
        width: 680px;
        // height: 50px;
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd2 {
        display: flex;
        justify-content: space-around;
        // border:1px solid #ccc;
        // padding:0 15px;
        box-sizing: border-box;
        .left_b {
          padding-right: 15px;
          flex: 1;
          // margin-left:20px;
          // text-align: center;
          border-right: 1px solid rgba(225, 225, 225, 1);
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
        .right_b {
          flex: 1;
          margin-left:15px;
          // text-align: center;
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
      }
    }
  }
  .rightTops {
    width: 297px;
    height: 277px;
    // border: 1px solid #ccc;
    .policyHeader {
      width: 297px;
      height: 36px;
      background: url('../assets/policy.png') no-repeat;
      // background-color: #fff;
      .policy_left {
        float: left;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        // text-align: center;
        margin-left: 14%;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .policyBody {
      width: 297px;
      height: 236px;
      border: 1px solid rgba(225, 225, 225, 1);
      margin-top: 7px;
      padding: 0 10px;
      box-sizing: border-box;
        .seamless-warp {
        width: 100%;
        height: 217px;
        overflow: hidden;
        ul {
          color: #93969b;
          .icon_top {
            font-size: 12px;
            padding-left: 5px;
            padding-right: 6px;
            border: 1px solid rgba(179, 0, 0, 1);
            color: rgba(179, 0, 0, 1);
            border-radius: 4px;
          }
          .icon_top:active {
            color: none;
          }
          li {
            display: flex;
            align-items: center;
            justify-content:space-between;
            box-sizing: border-box;
            width: 100%;
            height: 14px;
            line-height: 32px;
            padding: 20px 0;
            list-style: none;
            border-bottom: 1px dashed rgba(225, 225, 225, 1);
            .right_go {
              float: left;
              width: 5px;
              height: 9px;
              // background-color: red;
              background: url('../assets/right.png') no-repeat;
            }
            .first_text {
              font-size: 14px;
              flex: 1;
              margin-left: 5px;
            }
            span {
              color: #3d3d3d;
            }
            .first_text:hover {
              cursor: pointer !important;
              text-decoration: underline !important;
              color: #30699b !important;
            }
            .first_text:active {
              color: #30699b;
            }
            .c_date {
              float: right;
              color: #999ca1;
              // margin-right: 15px;
            }
          }
          li:nth-child(1) {
            padding-top: 0;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
.twoLine {
  // border: 1px solid #ccc;
  .openGo {
    width: 297px;
    height: 280px;
    // border: 1px solid #ccc;
  }
}
label > span:nth-child(1) {
  cursor: pointer;
}
label span:hover {
  color: rgb(21, 71, 119);
}
.test {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 30px;
  width: 260px;
  background-color: rgba(0, 54, 137, 0.58);
  line-height: 47px;
  color: white;
  text-align: left;
  padding-left: 10px;
  label {
    font-size: 16px;
    // font-weight: 900;
  }
}
.el-carousel__indicator--horizontal {
  border-radius: 50% !important;
  position: relative !important;
  left: 280px !important;
}
.el-carousel__button {
  height: 10px !important;
  width: 10px !important;
  border-radius: 50% !important;
}
/* 中间内容 start*/
.content {
  width: 100%;
  min-width: 1260px;
  // padding-top: 193px;
}
.c_rotation {
  // float: left;
  height: 217px;
  width: 260px;
  min-width: 260px;
  margin: 0 8px;
  // margin-left: 351px;
  // margin-left:20%;
  .el-carousel__indicator--horizontal{
    left: 0px !important;
  }
}
.c_rotation {
  img {
    width: 260px;
    height: 217px;
  }
}
.c_rightmes {
  // float: left;
  height: 217px;
  // margin-left: 18px;
}
.c_mes {
  // background: black;
  box-sizing: border-box;
  // border: 1px #ececec solid;
  // width: 362px;
  width: 410px;
  height: 217px;
  padding-left: 15px;
  .seamless-warp {
    width: 100%;
    height: 217px;
    overflow: hidden;
    ul {
      color: #93969b;
      .icon_top {
        font-size: 12px;
        padding-left: 5px;
        padding-right: 6px;
        border: 1px solid rgba(179, 0, 0, 1);
        color: rgba(179, 0, 0, 1);
        border-radius: 4px;
      }
      .icon_top:active {
        color: none;
      }
      li {
        display: flex;
        align-items: center;
        justify-content:space-between;
        box-sizing: border-box;
        width: 100%;
        height: 14px;
        line-height: 32px;
        padding: 20px 0;
        list-style: none;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        .right_go {
          float: left;
          width: 5px;
          height: 9px;
          // background-color: red;
          background: url('../assets/right.png') no-repeat;
        }
        .first_text {
          font-size: 14px;
          flex: 1;
          margin-left: 5px;
        }
        span {
          color: #3d3d3d;
        }
        .first_text:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #30699b;
        }
        .first_text:active {
          color: #30699b;
        }
        .c_date {
          float: right;
          color: #999ca1;
          // margin-right: 15px;
        }
      }
      li:nth-child(1) {
        padding-top: 0;
        margin-top: 20px;
      }
    }
  }
  
}

.c_mes2 {
  padding-left: 15px;
  width: 100%;
  height: 190px;
  border: none;
  border:1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  ul {
    width: 100%;
    height: 100%;
    padding:9px 0;
    li {
      font-size: 14px;
      list-style: none;
      padding-bottom:17px;
      &:last-child{
        padding-bottom:0;
      }
      span:hover {
        color: #30699b;
        cursor: pointer;
        text-decoration: underline
      }
    }
  }
}
.c_button {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  // margin-top: 12px;
  text-align: center;
  font-weight: 1000;
  line-height: 48px;
  color: #30699b;

}
.c_butlist {
  font-size: 16px;
  background: #f5f5f5;
  width: 305px;
  height: 57px;
  margin-top:14px;
  &:nth-child(1) {
  margin-top:0px;
    color: #c3892a;
    background: url('../assets/examination.png') no-repeat;
    &:hover{
      cursor: pointer;
      color: #ec9508;
    }
  }
  &:nth-child(2) {
    color: #d4875d;
    background: url('../assets/portal.png') no-repeat;
    &:hover{
      cursor: pointer;
      color: #e75506;
    }
  }
  &:nth-child(3) {
    color: #387eae;
    background: url('../assets/recruitment.png') no-repeat;
    &:hover{
      cursor: pointer;
      color: #00406a;
    }
  }
  &:nth-child(4) {
    color: #35532b;
    background: url('../assets/download.png') no-repeat;
    &:hover{
      cursor: pointer;
      color: #0b2502;
    }
  }
}
// .c_butlist:hover {
//   cursor: pointer;
//   color: rgb(21, 71, 119);
// }
// .c_left {
//   margin-left: 11px;
// }
.c_noticebox2 {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  // width: 959px;
  width: 1020px;
  // float: left;
  margin-left:inherit;
  // transform: translate(-50%);
  // margin: 0px 350px;
  // padding-left: 350px;
  // padding: 0 20%;
  display: flex;
  flex-direction: row;
  .c_row {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    height: 33px;
    width: 100%;
    // border-bottom: 3px solid #31689b;
    justify-content: space-between;
    margin-bottom:10px;
  }
  .c_noticetext {
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    margin-right: 16px;
    color: #c6c6c6;
  }
  .c_noticetext:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .c_frame {
    // border: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 21px;
    // width: 293px;
    width: 330px;
    height: 226px;
    background:url('../assets/BottomColumn.png') no-repeat;
    .c_noticelefttop {
      box-sizing: border-box;
      width: 98px;
      height: 33px;
      // background-color: #31689b;
      text-align: center;
      line-height: 33px;
      color: #2971b4;
      font-weight: 700;
      font-size: 14px;
      margin-bottom:10px;
    }
  }
}
.c_noticebox {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  // width: 959px;
  width: 1020px;
  // float: left;
  margin-left:50%;
  transform: translate(-50%);
  // margin: 0px 350px;
  // padding-left: 350px;
  // padding: 0 20%;
  display: flex;
  flex-direction: row;
  .c_row {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    height: 33px;
    width: 100%;
    // border-bottom: 3px solid #31689b;
    justify-content: space-between;
    margin-bottom:10px;
  }
  .c_noticetext {
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    margin-right: 16px;
    color: #c6c6c6;
  }
  .c_noticetext:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .c_frame {
    // border: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 21px;
    // width: 293px;
    width: 330px;
    height: 226px;
    background:url('../assets/BottomColumn.png') no-repeat;
    .c_noticelefttop {
      box-sizing: border-box;
      width: 98px;
      height: 33px;
      // background-color: #31689b;
      text-align: center;
      line-height: 33px;
      color: #2971b4;
      font-weight: 700;
      font-size: 14px;
      margin-bottom:10px;
    }
  }
}
// .c_noticebox > div:nth-last-child(1) {
//   margin-left: 22px;
// }
.c_img {
  box-sizing: border-box;
  float: left;
  // margin-left: 353px;
  // margin: 0px 350px;
  margin: 0 20%;
  height: 130px;
  width: 59%;
  margin-top: 21px;
  background-color: #a4ccee;
  border: 1px #ececec solid;
}

/* 中间内容 end*/
</style>
<style>
</style>
